<!--
Author: TangChen
Date: 2018-10-08
Desc: 手机号码绑定，由index.js 配置引入
 -->
<template>
    <div :class="'bizcomp-bind-mobile bizcomp ' + className">
        <comp-title :title="title" />
        <nav-tips :data="titTips" />
        <div class="acct-con">
            <div v-if="!checked" class="check-acct">
                <el-form
                    ref="pwdForm"
                    :model="pwdForm"
                    :rules="rules"
                    label-width="240px"
                    class="pwdForm"
                    inline-message
                    v-on:submit.native.prevent
                >
                    <el-form-item v-if="cbind" label="原手机号码：" class="form-text">
                        <div class="text-con">
                            {{ info.mobileno }}
                        </div>
                    </el-form-item>
                    <el-form-item :label="(cbind ? '新' : '') + '手机号码：'" prop="mobileno">
                        <el-input
                            v-model.trim="pwdForm.mobileno"
                            :placeholder="plaC"
                            :maxlength="11"
                        />
                    </el-form-item>
                    <el-form-item label="手机验证码：" prop="verifyCode" class="verifycode-row">
                        <!-- <el-input
                            v-model.trim="pwdForm.verifyCode"
                            placeholder="请输入手机验证码"
                            :maxlength="6"
                        >
                            <el-button
                                slot="append"
                                class="get-verify"
                                :disabled="time>0"
                                v-on:click="mobileCheck"
                            >
                                {{ btnMsg }}
                            </el-button>
                        </el-input> -->
                        <el-row>
                            <el-col :span="8">
                                <el-input
                                    v-model.trim="pwdForm.verifyCode"
                                    class="verifycode-style"
                                    placeholder="请输入手机验证码"
                                    :maxlength="6"
                                ></el-input>
                            </el-col>
                            <el-col :span="4">
                                <el-button
                                    class="get-verify"
                                    :disabled="time > 0"
                                    v-on:click="mobileCheck"
                                >
                                    {{ btnMsg }}
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item>
                        <div style="width: 50%">
                            <el-button
                                type="primary"
                                class="medium"
                                v-on:click="submitForm('pwdForm')"
                            >
                                下一步
                            </el-button>
                            <el-button class="medium" v-on:click="back">返回</el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <!-- <set-pwd v-if="resetPwd&&!tradeMust" :pwd-con="pwdSet" v-on:pwd-get="pwdOk" /> -->
            <!-- <div v-if="tradeMust&&!result" class="trade">
                <el-form
                    ref="tradePwd"
                    :model="pwdForm"
                    :rules="rules"
                    label-width="240px"
                    class="pwdForm"
                    inline-message
                    v-on:submit.native.prevent
                >
                    <el-form-item label="交易密码：" prop="pwd">
                        <el-input
                            v-model.trim="pwdForm.pwd"
                            type="password"
                            placeholder="请输入交易密码"
                            :maxlength="16"
                        />
                        <span class="redemp-btn" v-on:click.prevent="$router.push({name: 'tradepwd'})"><span class="like-a">忘记密码？</span></span>
                    </el-form-item>
                    <el-form-item>
                        <div style="width:50%;">
                            <el-button type="primary" class="medium" v-on:click="refreshTrade">
                                下一步
                            </el-button>
                            <el-button class="medium" v-on:click="back">
                                返回
                            </el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </div> -->
        </div>
        <img-code :dialog-visible="visible" v-on:verify-in="getVerifyCode" />
        <result
            v-if="result"
            :result="resultMes"
            v-on:login-now="backFrame"
            v-on:return-login="backcenter"
        />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import navTips from "@/components/form/navTips.vue";
import imgCode from "@/components/layout/imgCode.vue";
// import setPwd from "@/components/layout/setPwd.vue";
import result from "@/components/layout/result.vue";
import userApi from "@/api/user";

export default {
    name: "BindAcct",
    components: {
        navTips,
        result,
        // setPwd,
        imgCode
    },
    mixins: [mixin],
    data() {
        return {
            time: 0, // 验证码再次发送间隔
            pwdForm: {
                // 表单参数配置
                mobileno: "",
                verifyCode: "",
                pwd: ""
            },
            titTips: {
                tit: "您还未绑定手机号",
                text: "绑定后可通过手机号快速登录"
            },
            pwdSet: {
                btn1: "确认",
                text: "登录"
            },
            info: {},
            cbind: false,
            tradeMust: false,
            btnMsg: "获取验证码",
            plaC: "请输入手机号码",
            locked: false, // 是否已发送短信验证码
            checked: false,
            resetPwd: false,
            result: false,
            visible: false,
            setPwd: "",
            rules: {
                // 校验规则
                mobileno: [
                    { required: true, message: "请输入手机号码", trigger: "blur" },
                    { validator: this.mobileno, trigger: "blur" }
                ],
                verifyCode: [{ validator: this.$util.validateVerifyCode, trigger: "blur" }],
                pwd: [{ required: true, message: "请输入交易密码", trigger: "blur" }]
            },
            resultMes: {
                // 结果页面信息
                cla: "register-success",
                msg: "您已成功绑定登录手机为",
                btnL: {
                    text: "返回首页",
                    event: "login-now"
                },
                btnR: {
                    ctd: "秒后自动跳转个人中心",
                    time: 10,
                    event: "return-login"
                }
            }
        };
    },
    created() {
        this.info = this.$cache.getUser();
        if (this.info.mobileno.length === 11) {
            this.title = "修改绑定";
            this.plaC = "请输入新手机号码";
            this.cbind = true;
            this.titTips = {
                tit: "您的账号已绑定手机号" + this.info.mobileno,
                text: "您可以修改绑定其它手机号"
            };
        }
    },
    methods: {
        /* 提交表单数据,校验手机验证码 */
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (!this.locked) {
                        this.$message({
                            type: "warning",
                            message: "请先发送手机短信验证码"
                        });
                        return false;
                    }
                    this.checkVerifyCode();
                } else {
                    this.$errorScroll();
                }
            });
        },
        /* 密码表单回调数据 */
        pwdOk(action, val) {
            if (!action) {
                this.back();
            } else {
                this.setPwd = val.pwd;
                this.refreshTrade();
            }

            // if (!action) {
            //     this.back();
            // } else {
            //     this.setPwd = val.pwd;
            //     if(this.$cache.getPwdCheck("B1")){
            //         this.tradeMust = true;
            //     }else{
            //         this.refreshTrade();
            //     }
            // }
        },
        async refreshTrade() {
            let isDecryptObj = {};
            if (this.$cache.getIsEncrypted()) {
                isDecryptObj.en_originmobileno = this.$cache.getUser().en_mobileno;
            } else {
                isDecryptObj.originmobileno = this.info.mobileno || "";
            }
            const data = {
                ...isDecryptObj,
                mobileno: this.pwdForm.mobileno.replace(/\s/g, ""),
                smscode: this.pwdForm.verifyCode
            };

            const res = await userApi.modifyMobile(data, this.$cache.getIsEncrypted());

            if (res.code === "0") {
                this.checked = true;
                this.resetPwd = false;
                this.result = true;
                this.$cache.refreshUser();
                this.resultMes.msg += this.pwdForm.mobileno;
            }
        },
        // 校验手机号
        mobileno(rule, value, callback) {
            if (value === this.info.mobileno) {
                callback();
            } else {
                this.$util.validateMobile(rule, value, callback);
            }
        },
        /* 提交表单数据 */
        mobileCheck() {
            let _this = this;
            this.$refs.pwdForm.validateField("mobileno", function (str) {
                if (str === "") {
                    if (this.$cache.getSysParam("10103010") == "2") {
                        this.getVerifyCode("");
                    } else {
                        _this.visible = true;
                    }
                } else {
                    return false;
                }
            });
        },
        /* 校验手机验证码 */
        checkVerifyCode() {
            this.pwdOk(true, "");
        },
        /* 获取图形验证码值 */
        async getVerifyCode(val) {
            this.visible = false;
            if (val || this.$cache.getSysParam("10103010") == "2") {
                const res = await userApi.sendSms({
                    mobileno: this.pwdForm.mobileno,
                    biztype: this.$const.IMG_BIZTYPE.CHANGEMOBILE,
                    verifycode: val
                });
                if (res.code === "0") {
                    /* 倒计时 */
                    this.time = res.data.sendperiod;
                    this.locked = true;
                    this.$util.btnDisabled(this);
                } else {
                    this.$message({
                        type: "warning",
                        message: res.msg
                    });
                }
            }

            return false;
        },
        /* 回到登录页面 */
        backFrame() {
            this.$router.push("/home");
        },
        /* 返回登录页 */
        back() {
            this.$router.back();
        },
        /* 返回个人中心 */
        backcenter() {
            this.$router.push("/securitycenter");
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-bind-mobile {
    min-height: 400px;
    .acct-con {
        padding: 20px;
    }
    .check-acct {
        margin-top: 20px;
    }
    .pwdForm {
        .el-form-item {
            .el-select {
                width: 50%;
                .el-input {
                    width: 100%;
                }
            }
            &.form-text {
                margin-bottom: 10px;
                .text-con {
                    color: $text-color3;
                }
            }
            .el-form-item__label {
                color: $text-color3;
                &:before {
                    display: none;
                }
            }
            .el-input {
                width: 50%;
                &.verifycode-style {
                    width: 98%;
                }
                .get-verify {
                    color: var(--color-primary);
                    min-width: 140px;
                }
                .el-button.is-disabled {
                    color: $text-color3;
                }
                .fa {
                    margin-right: 6px;
                }
            }
            .get-verify {
                color: $color-b-o;
                min-width: 100px;
                width: 100%;
            }
            .el-button.is-disabled {
                color: $text-color3;
                background-color: transparent;
            }
            &.verifycode-row {
                > .el-form-item__content > .el-form-item__error {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
            .el-button + .el-button {
                float: right;
            }
            .el-form-item__error--inline {
                color: $color-c;
            }
        }
    }
}
</style>
